import classes from './ContactInfo.module.scss';
import phone from '../../../assets/img/Footer/phone.svg';
import mark from '../../../assets/img/Footer/mark.svg';
import email from '../../../assets/img/Footer/email.svg';
import icon_x from '../../../assets/img/social/x.svg';
import icon_youtube from '../../../assets/img/social/youtube.svg';
import icon_reddit from '../../../assets/img/social/reddit.svg';
import icon_tiktok from '../../../assets/img/social/tiktok.svg';
import icon_pinterest from '../../../assets/img/social/pinterest.svg';

const social = [
    {
        icon: icon_x,
        url: 'https://x.com/ArdAltaamir',
    },
    {
        icon: icon_youtube,
        url: 'https://www.youtube.com/@ArdAltamir',
    },
    {
        icon: icon_reddit,
        url: 'https://www.reddit.com/user/ArdAltaamir/',
    },
    {
        icon: icon_tiktok,
        url: 'https://www.tiktok.com/@ardaltaamir',
    },
    {
        icon: icon_pinterest,
        url: 'https://pin.it/22Z0aE2vF',
    },
];

const ContactInfo = () => {
    const { hostname } = document.location;
    return (
        <section className={classes.contactInfo}>
            <div className={classes.social}>
                {social.map((item, index) =>
                    <a
                        href={item.url}
                        target="_blank"
                        rel="noreferrer"
                        key={index}
                        className={classes.item}
                    >
                        <img className={classes.icon} src={item.icon} alt='' />
                    </a>
                )}
            </div>
            <h2 className={[classes.title, 'font-48'].join(' ')}>
                <span>
                    Contact Info
                </span>
            </h2>
            <div className={classes.content}>
                <div className={classes.contactUs}>
                    <p>
                        Contact us for any information
                    </p>
                    <div className={classes.contacts}>
                        <div className={classes.row}>
                            <img src={phone} alt='' />
                            <a href="tel:+971523252486">
                                +971 52 325 2486
                            </a>
                        </div>
                        <div className={classes.row}>
                            <img src={mark} alt='' />
                            <div>
                                Building 7, business Bay, Bay Square, Dubai, UAE
                            </div>
                        </div>
                        <div className={classes.row}>
                            <img src={email} alt='' />
                            <a href={`mailto:support@${hostname}`}>
                                support@{hostname}
                            </a>
                        </div>
                    </div>
                </div>
                <div className={classes.hours}>
                    <p>
                        Business Hours
                    </p>
                    <ul>
                        <li>
                            We work 6 days a week
                        </li>
                        <li>
                            Sun - Wed: 08:00 am - 05.30 pm
                        </li>
                        <li>
                            Thur - Fr: 08:00 am - 02:00 pm
                        </li>
                        <li>
                            Saturday: 08:00 am - 05:30 pm
                        </li>
                        <li>
                            Every Sunday is holiday
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default ContactInfo;
